// extracted by mini-css-extract-plugin
export default {"container":"style_container__Tib8r","returnBtn":"style_returnBtn__NBU9Y"};